import classNames from 'classnames'
import React from 'react'
import styles from './ListItemBody.module.scss'
import type { ListItemBodyProps } from './types'

const ListItemBody: React.FC<ListItemBodyProps> = ({
  className,
  title,
  description,
  hyperlink: Hyperlink,
  extraInfo,
  trailingTitle,
  trailingDescription,
  tag: Tag,
  badge: Badge,
}) => {
  return (
    <div className={classNames(styles['pintxo-list-item__body'], className)}>
      <div className={styles['pintxo-list-item__body__title']}>
        <span
          className={classNames(
            styles['pintxo-list-item__body__title__text'],
            'pintxo-typography-body1-emphasis'
          )}
        >
          {title}
        </span>
        {description && (
          <span
            className={classNames(
              styles['pintxo-list-item__body__title__description'],
              'pintxo-typography-body2'
            )}
          >
            {description}
          </span>
        )}
        {Hyperlink && Hyperlink}
        {extraInfo && (
          <span
            className={classNames(
              styles['pintxo-list-item__body__title__extra-info'],
              'pintxo-typography-body1'
            )}
          >
            {extraInfo}
          </span>
        )}
      </div>
      {trailingTitle && (
        <div className={classNames(styles['pintxo-list-item__body__trailing-title'], className)}>
          <span
            className={classNames(
              styles['pintxo-list-item__body__trailing-title__text'],
              'pintxo-typography-body1-emphasis'
            )}
          >
            {trailingTitle}
          </span>
          {trailingDescription && (
            <span
              className={classNames(
                styles['pintxo-list-item__body__trailing-title__description'],
                'pintxo-typography-body2'
              )}
            >
              {trailingDescription}
            </span>
          )}
        </div>
      )}
      {Tag && Tag}
      {Badge && Badge}
    </div>
  )
}

export default ListItemBody
